export const homeRoute = (user: { role: string } | null) => user ? '/' : '/login';
